import { DashboardModuleColor } from '../types';

export interface DashboardCardThemeDefinition {
  id: DashboardModuleColor;
  label: string;
  surfaceClassName: string;
  dividerClassName: string;
  handleClassName: string;
  badgeClassName: string;
  swatchClassName: string;
}

export const DASHBOARD_CARD_THEMES: DashboardCardThemeDefinition[] = [
  {
    id: 'default',
    label: '기본',
    surfaceClassName: 'border-white/20 bg-white/40',
    dividerClassName: 'border-white/20',
    handleClassName: 'bg-white/50 text-gray-500',
    badgeClassName: 'bg-fuchsia-100 text-fuchsia-700',
    swatchClassName: 'bg-fuchsia-400',
  },
  {
    id: 'rose',
    label: '로즈',
    surfaceClassName: 'border-rose-200/80 bg-rose-50/65',
    dividerClassName: 'border-rose-200/80',
    handleClassName: 'bg-white/75 text-rose-500',
    badgeClassName: 'bg-rose-100 text-rose-700',
    swatchClassName: 'bg-rose-400',
  },
  {
    id: 'amber',
    label: '앰버',
    surfaceClassName: 'border-amber-200/80 bg-amber-50/65',
    dividerClassName: 'border-amber-200/80',
    handleClassName: 'bg-white/75 text-amber-600',
    badgeClassName: 'bg-amber-100 text-amber-700',
    swatchClassName: 'bg-amber-400',
  },
  {
    id: 'emerald',
    label: '에메랄드',
    surfaceClassName: 'border-emerald-200/80 bg-emerald-50/65',
    dividerClassName: 'border-emerald-200/80',
    handleClassName: 'bg-white/75 text-emerald-600',
    badgeClassName: 'bg-emerald-100 text-emerald-700',
    swatchClassName: 'bg-emerald-400',
  },
  {
    id: 'sky',
    label: '스카이',
    surfaceClassName: 'border-sky-200/80 bg-sky-50/65',
    dividerClassName: 'border-sky-200/80',
    handleClassName: 'bg-white/75 text-sky-600',
    badgeClassName: 'bg-sky-100 text-sky-700',
    swatchClassName: 'bg-sky-400',
  },
  {
    id: 'violet',
    label: '바이올렛',
    surfaceClassName: 'border-violet-200/80 bg-violet-50/65',
    dividerClassName: 'border-violet-200/80',
    handleClassName: 'bg-white/75 text-violet-600',
    badgeClassName: 'bg-violet-100 text-violet-700',
    swatchClassName: 'bg-violet-400',
  },
  {
    id: 'teal',
    label: '틸',
    surfaceClassName: 'border-teal-200/80 bg-teal-50/65',
    dividerClassName: 'border-teal-200/80',
    handleClassName: 'bg-white/75 text-teal-600',
    badgeClassName: 'bg-teal-100 text-teal-700',
    swatchClassName: 'bg-teal-400',
  },
  {
    id: 'orange',
    label: '오렌지',
    surfaceClassName: 'border-orange-200/80 bg-orange-50/65',
    dividerClassName: 'border-orange-200/80',
    handleClassName: 'bg-white/75 text-orange-600',
    badgeClassName: 'bg-orange-100 text-orange-700',
    swatchClassName: 'bg-orange-400',
  },
  {
    id: 'indigo',
    label: '인디고',
    surfaceClassName: 'border-indigo-200/80 bg-indigo-50/65',
    dividerClassName: 'border-indigo-200/80',
    handleClassName: 'bg-white/75 text-indigo-600',
    badgeClassName: 'bg-indigo-100 text-indigo-700',
    swatchClassName: 'bg-indigo-400',
  },
  {
    id: 'lime',
    label: '라임',
    surfaceClassName: 'border-lime-200/80 bg-lime-50/65',
    dividerClassName: 'border-lime-200/80',
    handleClassName: 'bg-white/75 text-lime-700',
    badgeClassName: 'bg-lime-100 text-lime-800',
    swatchClassName: 'bg-lime-400',
  },
  {
    id: 'slate',
    label: '슬레이트',
    surfaceClassName: 'border-slate-200/80 bg-slate-50/65',
    dividerClassName: 'border-slate-200/80',
    handleClassName: 'bg-white/75 text-slate-600',
    badgeClassName: 'bg-slate-100 text-slate-700',
    swatchClassName: 'bg-slate-400',
  },
];

export const DEFAULT_DASHBOARD_CARD_THEME = DASHBOARD_CARD_THEMES[0];

export function getDashboardCardTheme(themeId?: DashboardModuleColor | null): DashboardCardThemeDefinition {
  return DASHBOARD_CARD_THEMES.find((theme) => theme.id === themeId) ?? DEFAULT_DASHBOARD_CARD_THEME;
}
